import React, { useState, useEffect } from "react";
import { useWallet } from "@/context/WalletContext";
import { Panel, Pill } from "@/components/croc/ui";
import { fmtUsd, fmtNum } from "@/lib/format";
import api from "@/lib/api";
import { Crown, PieChart, Radio, TrendingUp } from "lucide-react";

export const RankShareCard = () => {
  const { address } = useWallet();
  const [d, setD] = useState(null);

  useEffect(() => {
    if (!address) return;
    const load = () => api.chainUser(address).then(setD).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [address]);

  if (!address) return null;
  const rank = d?.rank;
  const pct = Math.round((rank?.progress ?? 0) * 100);

  return (
    <Panel data-testid="rank-share-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Crown className="w-4 h-4 gold-text" />
          <span className="font-display font-bold text-white">My Rank & Shares</span>
        </div>
        <Pill tone="emerald"><Radio className="w-3 h-3" /> On-chain</Pill>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="rounded-xl border border-white/10 bg-[#090E0B] p-4">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Current Rank</div>
          <div className="font-display font-bold text-white text-lg mt-1" data-testid="rank-name">{rank?.name ?? "Hatchling"}</div>
          <div className="text-[11px] text-muted-foreground mt-0.5">Team volume {fmtUsd(rank?.team_volume_usd ?? 0)}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-[#090E0B] p-4">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground flex items-center gap-1"><PieChart className="w-3 h-3" /> Shares</div>
          <div className="font-num font-bold emerald-text text-2xl mt-1" data-testid="share-count">{fmtNum(d?.shares ?? 0, 0)}</div>
          <div className="text-[11px] text-muted-foreground mt-0.5">$2,500 self-topup per share</div>
        </div>
      </div>

      {rank?.next_name ? (
        <div data-testid="rank-progress">
          <div className="flex items-center justify-between text-[11px] mb-1.5">
            <span className="text-muted-foreground flex items-center gap-1"><TrendingUp className="w-3 h-3" /> Next: <span className="text-white">{rank.next_name}</span></span>
            <span className="font-num text-white">{pct}%</span>
          </div>
          <div className="h-2 rounded-full bg-white/8 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#1CFD4C] to-[#1CFD4C] transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
          <div className="text-[10px] text-muted-foreground mt-1.5">Reach {fmtUsd(rank.next_volume)} team volume to rank up</div>
        </div>
      ) : (
        <div className="text-[11px] emerald-text">Top rank reached 🐊</div>
      )}
    </Panel>
  );
};
